<mat-card class="afiliaciones">
    <mat-card-header>
        <mat-card-title>Top ciudades</mat-card-title>
    </mat-card-header>
    <mat-card-content class="mt-4">
        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
        <div>
            <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis" [colors]="chartOptions.colors" [stroke]="chartOptions.stroke"
                [title]="chartOptions.title" [subtitle]="chartOptions.subtitle" [tooltip]="chartOptions.tooltip"></apx-chart>
        </div>
    </mat-card-content>
</mat-card>